var rootScopeRef;
var mainScopeRef;
var virtualsScopeRef;

angular.element(document).ready(function () {
    var injector = angular.element(document.querySelector('[ng-app]')).injector();
    rootScopeRef = injector.get('$rootScope');
    mainScopeRef = angular.element(document.querySelector('#mainController')).scope();
    virtualsScopeRef = angular.element(document.querySelector('#virtualsContainer')).scope();
});


safeCallNg = function(scopeRef, methodName, ...args) {
    try {
        if (!scopeRef) {
            throw new Error(`Scope reference is undefined for method '${methodName}'.`);
        }

        if (!methodName || typeof methodName !== 'string') {
            throw new Error(`Invalid method name: '${methodName}'.`);
        }

        const method = scopeRef[methodName];
        if (typeof method !== 'function') {
            throw new Error(`Method '${methodName}' does not exist on the scope.`);
        }

        method.apply(scopeRef, args);
        return { success: true };
    } catch (err) {
        const errorMsg = err instanceof Error ? err.message : err.toString();
        if (rootScopeRef?.config?.DebugJsConsoleLogEnabled) {
            console.error('# ERROR: safeCallNg() error: ' + errorMsg);
        }
        rootScopeRef?.createLog?.(2, 'safeCallNg()', '# ERROR: ' + errorMsg);
        return { success: false, error: errorMsg };
    }
}

/**
 * HeartBeat for native app
 * @returns {boolean}
 */
heartBeat = function () {
  return true;
}

/**
 * Biometry login from native app
 * @returns {boolean}
 */
biometryLogin = function () {
  return true;
}

/**
 * Biometry again from native app
 * @returns {boolean}
 */
biometryAgain = function () {
  return true;
}

/**
 * Biometry login from native app
 * @returns {boolean}
 */
setLanguage = function (lang) {
  rootScopeRef?.config?.DebugJsConsoleLogEnabled && console.log('# INFO: setLanguage()');
  listenTopScreen('setLanguage', lang);
  return true;
}

/**
 * Function is called from/through native App.
 *
 * @param {string} type - The type of the event.
 * @param {Object} data - The data object containing screen details.
 * @param {boolean} data.screenShow - Whether the screen should be shown.
 * @param {'sport'|'region'|'league'|'event'|'lastMinute'} data.screenFor - The screen type.
 * @param {number} [data.sportID] - Sport ID (optional).
 * @param {number} [data.regionID] - Region ID (optional).
 * @param {number} [data.leagueID] - League ID (optional).
 * @param {number} [data.eventID] - Event ID (optional).
 */
listenTopScreen = function (type, data) {
  rootScopeRef?.config?.DebugJsConsoleLogEnabled && console.log("# INFO: listenTopScreen('" + type + "','" + data + "')");

  if (data && data !== 'undefined') {
    data = parseJSON(data);
  }
  // rootScopeRef?.createLog(
  //   3,
  //   "ScreenApp_Received_Message_STACK",
  //   [
  //   `key: ${type}
  //   data: ${JSON.stringify(data)}
  //   stack:${new Error().stack}`
  //   ].join("\n")
  // );
  try {
    switch (type) {
      case 'statsTable': // Edited logic
        if (data.eventID) {
          // Zobrazi analyzu
          safeCallNg(mainScopeRef, 'togglePrematch', data);
        } else {
          // Prematch close (FORCED)
          safeCallNg(mainScopeRef, 'togglePrematch', null, true);
          if (data.leagueID) {
            // League table
            safeCallNg(mainScopeRef, 'toggleBetRadarStats', data);
          }
        }
        break;
      // case 'statsTable': // Original logic
      //   if (!(data.eventID) && !(data.eStreamID)) {
      //     if (data && data.screenShow === false) {
      //       safeCallNg(virtualsScopeRef, 'hideVirtuals');
      //     }
      //     // Prematch close (FORCED)
      //     safeCallNg(mainScopeRef, 'togglePrematch', null, true);
      //     // League table
      //     safeCallNg(mainScopeRef, 'toggleBetRadarStats', data);
      //   } else {
      //     // Prematch (Analysis)
      //     safeCallNg(mainScopeRef, 'togglePrematch', data);
      //   }
      //   break;
      case 'loadBanners':
        setTimeout(function () {
            safeCallNg(mainScopeRef, 'loadBanners', data);
        }, 2000);
        break;
      case 'video':
          safeCallNg(mainScopeRef, 'loadVideo', data);
        break;
      case 'restart':
          safeCallNg(mainScopeRef, 'closeAllWhenRestart');
        break;
      case 'jackpot':
          safeCallNg(mainScopeRef, 'toggleJackpot');
        break;
      case 'jackpotChanged':
      case 'JackpotChanged':
          safeCallNg(mainScopeRef, 'jackpotChanged', data);
        break;
      case 'quickbet':
          safeCallNg(mainScopeRef, 'toggleQuickbet', data);
        break;
      case 'quickbetControl':
          safeCallNg(mainScopeRef, 'quickbetControl', data);
        break;
      case 'virtuals':
          safeCallNg(mainScopeRef, 'toggleVirtuals', data);
        break;
      case 'virtualsEvona':
          safeCallNg(mainScopeRef, 'toggleVirtualsEvona', data);
        break;
      case 'virtualsEvonaHub':
          safeCallNg(mainScopeRef, 'virtualsEvonaHub', data);
        break;
      case 'lottery':
          safeCallNg(mainScopeRef, 'toggleLottery', data);
        break;
      case 'showHelpSRT':
          safeCallNg(mainScopeRef, 'showHelpSRT');
        break;
      case 'hideHelpSRT':
          safeCallNg(mainScopeRef, 'hideHelpSRT');
        break;
      case 'biometryAutentification':
          data.credentials || (data.credentials = "biometry");
          safeCallNg(mainScopeRef, 'biometryResolve', data);
        break;
       case 'privateAccess':
       case 'biometryLogin':
          safeCallNg(mainScopeRef, 'biometryLogin', data);
        break;
       case 'biometryOnboarding':
          safeCallNg(mainScopeRef, 'autoCaptureOnboarding', data);
         break;
      case 'teamAnalysis':
        safeCallNg(mainScopeRef, 'toggleTeamAnalysis', data);
        break;
      case 'matchTracker':
        // MatchTracker close (FORCED)
        if (!data.eventID) {
            safeCallNg(mainScopeRef, 'toggleMatchtracker', null, true);
        }
        safeCallNg(mainScopeRef, 'toggleMatchtracker', data);
        break;
      case 'matchTrackerControl':
        safeCallNg(mainScopeRef, 'matchTrackerControl', data);
        break;
      case 'vlc':
        safeCallNg(mainScopeRef, 'toggleVlc', data);
        break;
      case 'stream':
        // Stream close (FORCED)
        if (!data.eStreamID) {
          safeCallNg(mainScopeRef, 'toggleStream', null, true);
        }
        safeCallNg(mainScopeRef, 'toggleStream', data);
        break;
      case 'setLanguage':
        safeCallNg(mainScopeRef, 'language', data);
        break;
      case 'test':
        // synchronna odpoved na volanie spodnej app
        return 'If you can read this message on bottom screen, synchronous command from bottom app was successful';
        break;
      case 'test-cmd-to-bottom':
        // Volanie vrchna app na spodnu s odpovedou na vrchnu backcall = 'test'
        safeCallNg(mainScopeRef, 'BottomScreen', 'test', '{}', true);
        break;
      case 'devContextMenuCommand':
        // Posielanie dev prikazov z vrchnej app na spodnu, prikazy su definovane v dev-context-menu.js
        safeCallNg(mainScopeRef, 'BottomScreen', 'devContextMenuCommand', data, true);
        break;
      case 'toastNotification':
        safeCallNg(mainScopeRef, 'toggleToastNotification', data);
        break;
      case 'watcher':
        safeCallNg(mainScopeRef, 'mediaDisableProtection', data);
        break;
    }
  } catch (err) {
      const stack = err instanceof Error ? err.stack : new Error().stack;
      rootScopeRef?.createLog(
      3,
      "ScreenApp_Received_Message_STACK_ERROR1",
      [
        `key: ${type}`,
        `data: ${safeData}`,
        `err: ${String(err)}`,
        `stack: ${stack}`
      ].join("\n")
      );
    rootScopeRef?.config?.DebugJsConsoleLogEnabled && console.log('# ERROR: listenTopScreen() err: ' + err.toString());
  };
}

/**
 * Parse from JSON to JS object if possible.
 * If input is not a string, returns it unchanged.
 * If parsing fails, returns the original string.
 *
 * @param {string|object} data - JSON string or object to parse
 * @returns {object|string} Parsed object, original object, or original string
 */
parseJSON = function (data) {
  if (typeof data !== 'string') {
    // Vrati povodnu hodnotu
  	return data;
  }
  try {
    // Pokus o parsovanie
  	return JSON.parse(data);
  } catch(e) {
  	console.log('Catched: ' + e);
    // Pretoze sa nepodarilo parsovat JSON vrati povodnu string hodnotu
  	return data;
  }
}
